import { buildPermission } from "common/utils/auth";
import { EquipmentSubpath, Path } from "portal/utils/routing";
import { Header } from "portal/components/header/Header";
import { IconButton, Typography } from "@mui/material";
import { Page } from "portal/components/Page";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { TractorArchetypeForm } from "./TractorArchetypeForm";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { FC } from "react";

interface EditTractorArchetypeProps {}
export const _EditTractorArchetype: FC<EditTractorArchetypeProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { archetypeId } = useParams();
  return (
    <Page>
      <Header
        title={t("views.autotractor.equipment.tractors.editTractorArchetype")}
      />
      <div className="flex flex-col">
        <div className="flex gap-2">
          <IconButton
            color="info"
            onClick={() =>
              navigate(`${Path.EQUIPMENT}${EquipmentSubpath.TRACTORS}`)
            }
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" className="my-auto">
            {t("views.autotractor.equipment.tractors.editTractorArchetype")}
          </Typography>
        </div>
        <TractorArchetypeForm archetypeId={archetypeId} />
      </div>
    </Page>
  );
};

export const EditTractorArchetype = withAuthorizationRequired(
  buildPermission(
    PermissionAction.update,
    PermissionResource.atk_equipment,
    PermissionDomain.all
  ),
  _EditTractorArchetype
);
